import userStore from '@/store/user';
import { observer } from 'mobx-react-lite';

const AgentShare = observer(({ onClick=()=>{}, wrapClassName="", imgClassName="" }) => {
  if(userStore.isBrand) return null;
  return (
    <div 
      className={`h-32px box-border flex items-center gap-6px rounded-full border-1px border-black border-opacity-16 border-solid px-12px hover:bg-[rgba(0,0,0,0.03)] cursor-pointer ${wrapClassName}`}
      onClick={() => {
        onClick && onClick()
      }}
    >
      <img 
        src="https://p5.ssl.qhimg.com/t110b9a930160933f2e04de88d9.png" 
        className={`size-16px ${imgClassName}`}
        alt="" 
      />
      <div className='text-14px text-black'>分享智能体</div>
    </div>
  )
})

export default AgentShare